document.addEventListener("DOMContentLoaded", function () {

  const container = document.getElementById("articles-container");
  const blogElement = document.querySelector(".custom-blog");
  const topicFilters = document.querySelectorAll(".tag-filter li");
  const authorFilters = document.querySelectorAll(".blog-author-item");

  if (!container || !blogElement) return;

  const blogUrl =
    blogElement.dataset.blogUrl || "/blogs/resources";

  let nextPageUrl =
    document.getElementById("load-more-btn")?.dataset.nextUrl || null;

  let activeTag = "";
  let activeAuthor = "";


  /* =========================================
     HELPERS
  ========================================= */

  function normalizeText(value) {
    return (value || "")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();
  }


  function getCardAuthor(card) {

    const authorLine = card.querySelector(".blog-date");

    if (!authorLine) return "";

    const text = authorLine.textContent || "";
    const parts = text.split("|");

    return normalizeText(parts[0]);
  }


  /* =========================================
     TOPIC ACTIVE STATE
  ========================================= */

  function setActiveTopic(el) {

    topicFilters.forEach(function (filter) {
      filter.classList.remove("active");
    });

    if (el) {
      el.classList.add("active");
    }
  }


  function setTopicToAll() {

    const allTopic =
      Array.from(topicFilters).find(function (filter) {
        return (filter.dataset.tag || "") === "";
      });

    setActiveTopic(allTopic);

    activeTag = "";

    const toggle =
      document.querySelector(".dropdown-toggleb");

    const label =
      toggle?.querySelector("span:first-child");

    if (label) {
      label.textContent = "Filter By Topics";
    }
  }


  function updateDropdownLabel(el) {

    const toggle =
      document.querySelector(".dropdown-toggleb");

    if (!toggle || !el) return;

    const label =
      toggle.querySelector("span:first-child");

    if (!label) return;

    label.textContent =
      el.dataset.tag === ""
        ? "Filter By Topics"
        : el.textContent.trim();
  }


  /* =========================================
     AUTHOR ACTIVE STATE
  ========================================= */

  function setActiveAuthor(el) {

    authorFilters.forEach(function (filter) {
      filter.classList.remove("active");
    });

    if (el) {
      el.classList.add("active");
    }
  }


  function setAuthorToAll() {

    const allAuthors =
      Array.from(authorFilters).find(function (filter) {
        return (
          filter.getAttribute("data-author-name") || ""
        ) === "";
      });

    setActiveAuthor(allAuthors);

    activeAuthor = "";
  }


  /* =========================================
     AUTHOR FILTER
  ========================================= */

  function applyAuthorFilter() {

    const cards =
      container.querySelectorAll(".blog-card");

    const normalizedAuthor =
      normalizeText(activeAuthor);

    cards.forEach(function (card) {

      /*
       * No author selected:
       * show every loaded card.
       */
      if (!normalizedAuthor) {
        card.style.removeProperty("display");
        return;
      }

      const cardAuthor =
        getCardAuthor(card);

      if (cardAuthor === normalizedAuthor) {
        card.style.removeProperty("display");
      } else {
        card.style.display = "none";
      }

    });
  }


  /* =========================================
     LOAD ARTICLES
  ========================================= */

  function loadArticles(tag) {

    let url = blogUrl;

    if (tag) {
      url += "/tagged/" + encodeURIComponent(tag);
    }

    fetch(url)
      .then(function (response) {
        return response.text();
      })

      .then(function (data) {

        const html =
          new DOMParser().parseFromString(
            data,
            "text/html"
          );

        const newContainer =
          html.querySelector("#articles-container");

        const newBtn =
          html.querySelector("#load-more-btn");

        if (!newContainer) return;


        /*
         * Replace only the right article column.
         * Sidebar remains unchanged.
         */
        container.innerHTML =
          newContainer.innerHTML;


        nextPageUrl =
          newBtn
            ? newBtn.dataset.nextUrl
            : null;


        /*
         * If we're in Author mode,
         * filter the newly loaded full blog.
         */
        if (activeAuthor) {
          applyAuthorFilter();
        }

      })

      .catch(function (error) {

        console.error(
          "Aura Baby blog filter error:",
          error
        );

      });
  }


  /* =========================================
     TOPIC SELECTION
     
     Choosing a topic automatically clears
     the Author filter.
  ========================================= */

  function selectTag(tag) {

    const matchingFilter =
      Array.from(topicFilters).find(
        function (filter) {
          return (filter.dataset.tag || "") === tag;
        }
      );

    if (!matchingFilter) return;


    /*
     * Topic and Author filters are exclusive.
     */
    activeAuthor = "";
    setAuthorToAll();


    activeTag = tag;

    setActiveTopic(matchingFilter);
    updateDropdownLabel(matchingFilter);

    loadArticles(tag);
  }


  topicFilters.forEach(function (item) {

    item.addEventListener(
      "click",
      function () {

        const tag =
          this.dataset.tag || "";


        /*
         * Clear selected Author.
         */
        activeAuthor = "";
        setAuthorToAll();


        /*
         * Activate selected Topic.
         */
        activeTag = tag;

        setActiveTopic(this);
        updateDropdownLabel(this);

        loadArticles(tag);

      }
    );

  });


  /* =========================================
     AUTHOR SELECTION
     
     Choosing an author automatically clears
     the Topic filter and loads ALL articles
     before applying the Author filter.
  ========================================= */

  authorFilters.forEach(function (item) {

    item.addEventListener(
      "click",
      function () {

        const selectedAuthor =
          this.getAttribute(
            "data-author-name"
          ) || "";


        /*
         * Clear Topic selection and return
         * Topics visually to "All".
         */
        setTopicToAll();


        /*
         * Set selected Author.
         */
        activeAuthor =
          selectedAuthor;

        setActiveAuthor(this);


        /*
         * IMPORTANT:
         *
         * Reload the main unfiltered blog first.
         *
         * This prevents an Author from being
         * filtered only within a previously
         * selected Topic.
         */
        loadArticles("");

      }
    );

  });


  /* =========================================
     LOAD MORE
  ========================================= */

  function loadMore() {

    if (!nextPageUrl) return;

    fetch(nextPageUrl)
      .then(function (response) {
        return response.text();
      })

      .then(function (data) {

        const html =
          new DOMParser().parseFromString(
            data,
            "text/html"
          );

        const sourceGrid =
          html.querySelector(
            "#articles-container .articles"
          );

        const articleGrid =
          container.querySelector(".articles");

        const newBtn =
          html.querySelector("#load-more-btn");

        if (!sourceGrid || !articleGrid) return;


        const newCards =
          sourceGrid.querySelectorAll(".blog-card");


        newCards.forEach(function (card) {

          articleGrid.appendChild(
            card.cloneNode(true)
          );

        });


        /*
         * Update pagination.
         */
        if (newBtn) {

          nextPageUrl =
            newBtn.dataset.nextUrl;

          const currentBtn =
            document.getElementById(
              "load-more-btn"
            );

          if (currentBtn) {
            currentBtn.dataset.nextUrl =
              nextPageUrl;
          }

        } else {

          document
            .getElementById("load-more-btn")
            ?.remove();

          nextPageUrl = null;

        }


        /*
         * If Author mode is active,
         * apply it to newly loaded articles.
         */
        if (activeAuthor) {
          applyAuthorFilter();
        }

      })

      .catch(function (error) {

        console.error(
          "Aura Baby blog load more error:",
          error
        );

      });
  }


  /*
   * Event delegation because the contents of
   * #articles-container change after filtering.
   */
  document.addEventListener(
    "click",
    function (event) {

      const loadMoreButton =
        event.target.closest(
          "#load-more-btn"
        );

      if (!loadMoreButton) return;

      event.preventDefault();

      loadMore();

    }
  );


  /* =========================================
     AUTHOR PAGE -> TOPIC HANDOFF
     
     Example:
     /blogs/resources?topic=prenatal-wellness
  ========================================= */

  const params =
    new URLSearchParams(
      window.location.search
    );

  const requestedTopic =
    params.get("topic");


  if (requestedTopic) {

    selectTag(requestedTopic);

    if (
      window.history &&
      window.history.replaceState
    ) {

      window.history.replaceState(
        {},
        document.title,
        blogUrl
      );

    }

  }

});